<template>
    <b-container fluid>
      <b-card
        class="m-4"
        header="Lista de absenteísmos"
        header-text-variant="white"
        header-tag="header"
        header-bg-variant="success"
        footer-tag="footer"
      >
        <b-card-text>
          <b-row>
            <b-col>
              <b-table
                id="tabelaPlantoes"
                :items="myProvider"
                :per-page="perPage"
                :current-page="currentPage"
                :fields="campos_tabela"
                @row-clicked="rowSelected"
                show-empty
                empty-text="Você não possui absenteísmos para justificar. Parabéns!"
                small
              >
                <template v-slot:row-details="row">
                  <!-- <p>{{ row }}</p> -->
                  <b-container v-show="loading">
                    <b-row>
                      <b-col class="d-flex justify-content-center"><b-spinner label="Spinning"></b-spinner></b-col>
                    </b-row>
                    
                  </b-container>
                  
                  <b-container v-show="!loading">                  
                   
                    <b-form-textarea
                    id="textarea"
                    v-model="justificativa"
                    placeholder="Insira sua justificativa..."
                    rows="2"
                    ></b-form-textarea>    
                
                    <b-button class="mt-2" size="sm" variant="success" @click="salvar">Salvar</b-button>            
                  </b-container>  
                </template>
  
                <template v-slot:cell(data_refeicao)="data">
                  <!-- `data.value` is the value after formatted by the Formatter -->
                  <p>
                    {{
                      data.item.data_refeicao
                        | moment("DD/MM/YYYY")
                    }}
                  </p>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="d-flex justify-content-center">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                size="sm"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-card-text>
      </b-card>

      <b-alert
        v-model="alertaErro"
        class="position-fixed fixed-bottom m-0 rounded-0"
        style="z-index: 2000;"
        variant="danger"
        dismissible
      >
        <h4>Há erros no formulário</h4>
        <ul>
          <li v-for="(item, index) in mensagensErro" :key="index">{{ item }}</li>
        </ul>
      </b-alert>
    </b-container>
  </template>
  
  <script>

  import mixinToast from "@/mixins/mixinToast";
  
  export default {
    mixins: [mixinToast],
    components: {
      
    },
    data() {
      return {
        alertaErro: false,
        mensagensErro: [],
        profissionalSelecionado: null,
        plantao: null,
        currentPage: 1,
        perPage: 5,
        loading: false,
        justificativa: null,
        confirmacao_id_atual: null,
        totalRows: 0,
        campos_tabela: [
          { key: "refeicao", label: "Refeição" },
          { key: "data_refeicao", label: "Data" },
          { key: "id", label: "ID", class: 'd-none'}
        ],
        plantoes: [],
      };
    },
    methods: {
      rowSelected(item) {        


        if (this.linhaAberta != null) {
          if (this.linhaAberta === item) {
            this.linhaAberta._showDetails = !this.linhaAberta._showDetails;
            console.log('L1')
          } else {
            if (this.linhaAberta._showDetails)
              this.linhaAberta._showDetails = false;
              console.log('L2')
            item._showDetails = !item._showDetails;
            this.linhaAberta = item;
            console.log('L4')
          }
        } else {
          item._showDetails = !item._showDetails;
          this.linhaAberta = item;
          console.log('L3')
        }

        if (this.linhaAberta._showDetails){
          this.confirmacao_id_atual = item.id
          this.loading = true

          this.$http({
            url: `/justificativaporid`,
            params: {
              confirmacao_id: this.confirmacao_id_atual
            }
          }).then((response) => {
            this.justificativa = response.data ? response.data.justificativa : null
            console.log(response)
              // let contador = 0
              // while ( this.justificativa == null && contador < 10 ){
              //   self.loading = true
              //   contador++
              // }
              this.loading = false
        })}

      },
      exibeModal(item) {
        this.$refs.modalTrocaPlantao.show();
        this.profissionalSelecionado = null;
        this.plantao = item;
        console.log(item);
      },
      myProvider(ctx) {
        return this.$http
          .get(
            `/meusabsenteismos?limit=${ctx.perPage}&page=${ctx.currentPage}&cpf=${this.$store.getters.getLoggedUser.cpf}`
          )
          .then((result) => {
            this.totalRows = result.data.totalRows;
            return result.data.dados.map((item) => {
              item._showDetails = false;
              return item;
            });
          });
      },
      salvar(){
        this.$http.post('/salvarjustificativa', {
            confirmacao_id: this.confirmacao_id_atual,
            justificativa: this.justificativa.trim()
          }
        ).then((result) => {
									this.exibeToast(
										result.data.success,
										result.data.message
									);
								});
      }
    },
    mounted() {},
  };
  </script>
  
  <style></style>]
  